module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _vm._v(" I am greatly indebted to many published and unpublished diaries, letters and journals of women who settled the West. I hope their strong, honest voices can be heard in this book.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_vm._v("I’m grateful to Tony Wolk and Dee Anne Westbrook, who read the manuscript with care and perception; and to Ed, who gave me time, encouragement, applause.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_vm._v("I must also thank my dad, who introduced me to the public library, and to the panorama of the real and imagined West.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d456e654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 66
// module chunks = 0